// import {
//   Box,
//   CardContent,
//   Typography,
//   Grid,
//   Paper,
//   useTheme,
//   Chip,
//   Tooltip,
// } from "@mui/material";
// import { TagCloud } from "react-tagcloud";
// import SentimentGraph from "./SentimentGraph";
// import InfoIcon from "@mui/icons-material/Info";
// import { palette, theme as colorTheme} from "../../../../Convoze.theme";

//   const primary = colorTheme('palette', 'primary').value
//   const primaryBg = colorTheme('palette', 'primaryBg').value
//   const positive = colorTheme('palette', 'positive').value
//   const positiveBg = colorTheme('palette', 'positiveBg').value
//   const negative = colorTheme('palette', 'negative').value
//   const negativeBg = colorTheme('palette', 'negativeBg').value
//   const neutral = colorTheme('palette', 'neutral').value
//   const neutralBg = colorTheme('palette', 'neutralBg').value
//   const agent = colorTheme('palette', 'agent').value
//   const agentBg = colorTheme('palette', 'agentBg').value

// const CustomerSentiment = ({ customerAnalytics }) => {
//   const theme = useTheme();
//   console?.log(customerAnalytics, "customer analytics");
//   const emotionalPhrases =
//     customerAnalytics?.VoiceAndSentimentInsights?.KeyEmotionalPhrases;

//   const toneShifts =
//     customerAnalytics?.VoiceAndSentimentInsights?.ToneShiftsAndSilences;

//   const themeCloudData = customerAnalytics?.KeywordsAndThemes?.ThemeCloud;

//   const sentimentGraph =
//     customerAnalytics?.VoiceAndSentimentInsights?.EmotionTrendGraph[0]
//       ?.SentimentGraphData;

//   const customRenderer = (tag, size) => {

//     const primary = colorTheme('palette', 'primary').value;
//     const primaryBg = colorTheme('palette', 'primaryBg').value;
//     const positive = colorTheme('palette', 'positive').value;
//     const positiveBg = colorTheme('palette', 'positiveBg').value;
//     const negative = colorTheme('palette', 'negative').value;
//     const negativeBg = colorTheme('palette', 'negativeBg').value;
//     const neutral = colorTheme('palette', 'neutral').value;
//     const neutralBg = colorTheme('palette', 'neutralBg').value;
//     const agent = colorTheme('palette', 'agent').value;
//     const agentBg = colorTheme('palette', 'agentBg').value;

//      const colors = [
//        primary,
//        positive,
//        neutral,
//        negative,
//        agent,
//        primary
//     ];

//     const color = colors[Math.floor(Math.random() * colors.length)];
//     return (
//       <span
//         key={tag?.value}
//         style={{
//           display: "inline-block",
//           margin: "8px",
//           padding: "5px 10px",
//           fontSize: `${size}px`,
//           // backgroundColor: color,
//           color: color,
//           borderRadius: "6px",
//           fontWeight: 500,
//         }}
//       >
//         {tag?.value}
//       </span>
//     );
//   };

//   const colors = [ negativeBg, positiveBg, primaryBg,neutralBg]

//   return (
//     <Box sx={{ flexGrow: 1 }}>
//       <Grid container spacing={3}>
//         {/* Customer Profile Card */}
//         <Grid item xs={12} md={4}>

//           <Grid
//             container
//             spacing={3}
//             sx={{ display: "flex", flexDirection: "column" }}
//           >
//             <Grid item xs={12}>
//               <Paper
//                 sx={{
//                   flex: 1,
//                   p: 1.5,
//                   border: "1px solid #e0e0e0",
//                   borderRadius: 2,
//                 }}
//               >
//                 <Box sx={{ position: "relative" }}>
//                   <Box
//                     component="img"
//                     src="https://plus.unsplash.com/premium_vector-1721131162397-943dc390c744?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cGVyc29ufGVufDB8fDB8fHww"
//                     alt="Customer"
//                     sx={{
//                       width: "100%",
//                       height: 150,
//                       objectFit: "contain",
//                     }}
//                   />
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       bottom: 0,
//                       left: 0,
//                       right: 0,
//                       p: 2,
//                       background:
//                         "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))",
//                     }}
//                   >
//                     {/* <Typography
//                     variant="h5"
//                     component="div"
//                     sx={{ color: "white", fontWeight: 500 }}
//                   >
//                     {customerAnalytics?.CustomerProfile?.CustomerName}
//                   </Typography> */}
//                   </Box>
//                 </Box>

//                 <CardContent>
//                   <Typography variant="body1" mb={2} gutterBottom>
//                     Customer Profile
//                   </Typography>
//                   <Box
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       mb: 1,
//                     }}
//                   >
//                     <Typography variant="body2" color="text.secondary">
//                       Customer Name
//                     </Typography>
//                     <Typography variant="body2" fontWeight="500">
//                       {customerAnalytics?.CustomerProfile?.CustomerName || "NA"}
//                     </Typography>
//                   </Box>

//                   <Box
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       mb: 1,
//                     }}
//                   >
//                     <Typography variant="body2" color="text.secondary">
//                       Score
//                     </Typography>
//                     <Typography variant="body2" fontWeight="500">
//                       {customerAnalytics?.CustomerIntentAndPainPointDetection
//                         ?.CustomerExperienceScore?.Score || "N/A"}
//                     </Typography>
//                   </Box>

//                   <Box
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                     }}
//                   >
//                     <Typography variant="body2" color="text.secondary">
//                       Rating
//                     </Typography>
//                     <Typography variant="body2" fontWeight="500">
//                       {customerAnalytics?.CustomerIntentAndPainPointDetection
//                         ?.CustomerExperienceScore?.Rating || "N/A"}
//                     </Typography>
//                   </Box>
//                 </CardContent>
//               </Paper>
//             </Grid>
//             <Grid item xs={12}>
//               <Paper
//                 elevation={1}
//                 sx={{ flex: 1, p: 2.2, borderRadius: 2, py: 2.5 }}
//               >
//                 <Typography
//                   variant="body2"
//                   gutterBottom
//                   sx={{ display: "flex", alignItems: "center", gap: 1 }}
//                 >
//                   Frequently Used Words
//                   <Tooltip
//                     title="Gives the most frequently used words during the conversation from the customers side."
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >
//                     <InfoIcon
//                       sx={{
//                         fontSize: 18,
//                         color: "grey",
//                       }}
//                     />
//                   </Tooltip>
//                 </Typography>
//                 <Box
//                   sx={{
//                     mb: 2,
//                     mt: 2,
//                     borderRadius: 3,
//                     bgcolor: "#f9fafb",
//                     border: "1px solid #e5e7eb",
//                     p: 2,
//                     py: 3,
//                   }}
//                 >
//                   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                     {customerAnalytics?.KeywordsAndThemes?.FrequentKeywords
//                       ?.length > 0 ? (
//                       customerAnalytics?.KeywordsAndThemes?.FrequentKeywords?.map(
//                         (word, index) => (
//                           <Chip
//                             key={index}
//                             size="small"
//                             label={`${word}`}
//                             sx={{
//                               backgroundColor: colors[index % colors.length],
//                               // color: textColors[index % textColors.length],
//                               color:"black",
//                               fontWeight: 400,
//                               fontSize: "0.875rem",
//                             }}
//                           />
//                         )
//                       )
//                     ) : (
//                       <Chip
//                         label="No data available."
//                         size="small"
//                         sx={{
//                           mt: 2,
//                           backgroundColor: "#E4E5E7",
//                           color: "#5F6062",
//                           fontWeight: 500,
//                           px: 1.5,
//                           py: 0.5,
//                           borderRadius: "4px",
//                         }}
//                       />
//                     )}
//                   </Box>
//                 </Box>
//               </Paper>
//             </Grid>
//           </Grid>

//           {/* Theme Cloud */}

//           {/* <Paper elevation={1} sx={{ p: 2, borderRadius: 2, height: "37%" }}>
//               <Typography
//                 variant="subtitle1"
//                 gutterBottom
//                 sx={{ display: "flex", alignItems: "center", gap: 1 }}
//               >
//                 Highlighted Keywords
//                 <Tooltip
//                   title="The frequently used words by the customer"
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <InfoIcon
//                     sx={{
//                       fontSize: 18,
//                       color: "grey",
//                     }}
//                   />
//                 </Tooltip>
//               </Typography>

//               <Box
//                 sx={{
//                   height: { md: "80%" },
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   borderRadius: 3,
//                   bgcolor: "#f9fafb",
//                   border: "1px solid #e5e7eb",
//                   px: 2,
//                 }}
//               >
//                 {Array.isArray(themeCloudData) && themeCloudData.length > 0 ? (
//                   <TagCloud
//                     tags={
//                       themeCloudData.length > 20
//                         ? themeCloudData.slice(0, 18)
//                         : themeCloudData
//                     }
//                     minSize={15}
//                     maxSize={35}
//                     renderer={customRenderer}
//                     shuffle={true}
//                   />
//                 ) : (
//                   <Chip
//                     label="No Keywords available."
//                     size="small"
//                     sx={{
//                       // mt: 2,
//                       backgroundColor: "#E4E5E7",
//                       color: "#5F6062",
//                       fontWeight: 500,
//                       px: 1.5,
//                       py: 0.5,
//                       borderRadius: "4px",
//                     }}
//                   />
//                 )}
//               </Box>
//             </Paper> */}
//           {/* </Box> */}
//         </Grid>

//         {/* Voice & Sentiment Insights */}
//         {/* <Grid item xs={12} md={8}> */}

//           {/* <Paper elevation={1} sx={{ p: 1, borderRadius: 2 }}> */}

//             {/* <CardContent> */}

//               {/* <Box
//                 sx={{ display: "flex", alignItems: "center", mb: 3, gap: 1 }}
//               >
//                 <Typography variant="body1">
//                   🎧 &nbsp; Voice & Sentiment Insights
//                 </Typography>
//                 <Tooltip
//                   title="Gives the emotional phrases and the emotional shifts along with the timestamp."
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <InfoIcon
//                     sx={{
//                       fontSize: 18,
//                       color: "grey",
//                     }}
//                   />
//                 </Tooltip>
//               </Box> */}

//               {/* <Typography variant="body2" mb={2} gutterBottom>
//                 Emotion Trend During Call
//               </Typography>
//               <Box
//                 sx={{
//                   height: 300,
//                   mb: 4,
//                   bgcolor: "#f9fafb",
//                   borderRadius: 3,
//                   p: 2,
//                 }}
//               >
//                 <SentimentGraph sentimentGraph={sentimentGraph} />
//               </Box> */}

//               {/* <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
//                 <Box sx={{ display: "flex", alignItems: "center", mr: 3 }}>
//                   <Box
//                     sx={{
//                       width: 10,
//                       height: 10,
//                       borderRadius: "50%",
//                       bgcolor: primary,
//                       mr: 1,
//                     }}
//                   />
//                   <Typography variant="body2">Customer</Typography>
//                 </Box>
//                 <Box sx={{ display: "flex", alignItems: "center" }}>
//                   <Box
//                     sx={{
//                       width: 10,
//                       height: 10,
//                       borderRadius: "50%",
//                       bgcolor: agent,
//                       mr: 1,
//                     }}
//                   />
//                   <Typography variant="body2">Agent</Typography>
//                 </Box>
//               </Box> */}

//               {/* <Grid container spacing={3}>

//                 <Grid item xs={12} md={6}>
//                   {Array.isArray(emotionalPhrases) &&
//                   emotionalPhrases?.length > 0 ? (
//                     <>
//                       <Typography variant="body2" gutterBottom>
//                         Key Emotional Phrases
//                       </Typography>
//                       {emotionalPhrases?.map((phrase, index) => (
//                         <Box
//                           key={index}
//                           sx={{
//                             mb: 2,
//                             p: 1,
//                             borderRadius: 1,
//                             bgcolor:colorTheme('palette', 'negativeBg').value,
//                             color:"black",
//                             border: "1px solid #ffebee",
//                           }}
//                         >
//                           <Box
//                             sx={{
//                               display: "flex",
//                               justifyContent: "space-between",
//                               mb: 1,
//                             }}
//                           >
//                             <Typography
//                               variant="body2"
//                               fontWeight="500"

//                               sx={{color:"black"}}
//                             >
//                               {phrase?.Phrase || phrase?.phrase}
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary">
//                               {phrase?.Timestamp || phrase?.timestamp}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       ))}
//                     </>
//                   ) : (
//                     <Typography variant="body2" color="text.secondary">
//                       No emotional phrases available.
//                     </Typography>
//                   )}
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   {Array.isArray(toneShifts) && toneShifts?.length > 0 ? (
//                     <>
//                       <Typography variant="body2" gutterBottom>
//                         Tone Shifts & Silences
//                       </Typography>
//                       {toneShifts?.map(
//                         (shift, index) => (
//                           (
//                             <Box
//                               key={index}
//                               sx={{
//                                 mb: 2,
//                                 p: 1,
//                                 borderRadius: 1,
//                                 bgcolor: "#f9fafb",
//                                 border: "1px solid lightgrey",
//                               }}
//                             >
//                               <Box
//                                 sx={{
//                                   display: "flex",
//                                   justifyContent: "space-between",
//                                   mb: 1,
//                                 }}
//                               >
//                                 <Typography variant="body2" fontWeight="500">
//                                   {shift?.Trigger||shift?.trigger || "NA"}
//                                 </Typography>
//                                 <Typography
//                                   variant="body2"
//                                   color="text.secondary"
//                                 >
//                                   {shift?.Timestamp||shift?.timestamp || "NA"}
//                                 </Typography>
//                               </Box>
//                               <Typography
//                                 variant="body2"
//                                 color="text.secondary"
//                               >
//                                 {shift?.Description||shift?.description || "NA"}
//                               </Typography>
//                             </Box>
//                           )
//                         )
//                       )}
//                     </>
//                   ) : (
//                     <Typography variant="body2" color="text.secondary">
//                       No tone shifts or silences detected.
//                     </Typography>
//                   )}
//                 </Grid>
//               </Grid> */}

//             {/* </CardContent> */}

//           {/* </Paper> */}

//         {/* </Grid> */}

//       </Grid>
//     </Box>
//   );
// };

// export default CustomerSentiment;

import {
  Box,
  CardContent,
  Typography,
  Grid,
  Paper,
  useTheme,
  Chip,
  Tooltip,
} from "@mui/material";
import { TagCloud } from "react-tagcloud";
import SentimentGraph from "./SentimentGraph";
import InfoIcon from "@mui/icons-material/Info";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";

const primary = colorTheme("palette", "primary").value;
const primaryBg = colorTheme("palette", "primaryBg").value;
const positive = colorTheme("palette", "positive").value;
const positiveBg = colorTheme("palette", "positiveBg").value;
const negative = colorTheme("palette", "negative").value;
const negativeBg = colorTheme("palette", "negativeBg").value;
const neutral = colorTheme("palette", "neutral").value;
const neutralBg = colorTheme("palette", "neutralBg").value;
const agent = colorTheme("palette", "agent").value;
const agentBg = colorTheme("palette", "agentBg").value;

const CustomerSentiment = ({ customerAnalytics, overview }) => {
  const theme = useTheme();
  console?.log(overview, "00----00");
  const emotionalPhrases =
    customerAnalytics?.VoiceAndSentimentInsights?.KeyEmotionalPhrases;

  const toneShifts =
    customerAnalytics?.VoiceAndSentimentInsights?.ToneShiftsAndSilences;

  const themeCloudData = customerAnalytics?.KeywordsAndThemes?.ThemeCloud;

  const sentimentGraph =
    customerAnalytics?.VoiceAndSentimentInsights?.EmotionTrendGraph[0]
      ?.SentimentGraphData;

  const customRenderer = (tag, size) => {
    const primary = colorTheme("palette", "primary").value;
    const primaryBg = colorTheme("palette", "primaryBg").value;
    const positive = colorTheme("palette", "positive").value;
    const positiveBg = colorTheme("palette", "positiveBg").value;
    const negative = colorTheme("palette", "negative").value;
    const negativeBg = colorTheme("palette", "negativeBg").value;
    const neutral = colorTheme("palette", "neutral").value;
    const neutralBg = colorTheme("palette", "neutralBg").value;
    const agent = colorTheme("palette", "agent").value;
    const agentBg = colorTheme("palette", "agentBg").value;

    const colors = [primary, positive, neutral, negative, agent, primary];

    const color = colors[Math.floor(Math.random() * colors.length)];
    return (
      <span
        key={tag?.value}
        style={{
          display: "inline-block",
          margin: "8px",
          padding: "5px 10px",
          fontSize: `${size}px`,
          // backgroundColor: color,
          color: color,
          borderRadius: "6px",
          fontWeight: 500,
        }}
      >
        {tag?.value}
      </span>
    );
  };

  const colors = [negativeBg, positiveBg, primaryBg, neutralBg];

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Grid container spacing={3} sx={{ display: "flex" }}>
            <Grid item xs={12} md={6}>
              <Paper
                sx={{
                  flex: 1,
                  p: 1.5,
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                }}
              >
                <Box sx={{ position: "relative" }}>
                  <Box
                    component="img"
                    src="https://plus.unsplash.com/premium_vector-1721131162397-943dc390c744?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cGVyc29ufGVufDB8fDB8fHww"
                    alt="Customer"
                    sx={{
                      width: "100%",
                      height: 150,
                      objectFit: "contain",
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      p: 2,
                      background:
                        "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))",
                    }}
                  ></Box>
                </Box>

                <CardContent>
                  <Typography variant="body1" mb={2} gutterBottom>
                    Customer Profile
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Customer Name
                    </Typography>
                    <Typography variant="body2" fontWeight="500">
                      {customerAnalytics?.CustomerProfile?.CustomerName || "NA"}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Sentiment Score
                    </Typography>
                    <Typography variant="body2" fontWeight="500">
                      {overview?.SentimentScores?.Customer?.score || "N/A"}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Rating
                    </Typography>
                    <Typography variant="body2" fontWeight="500">
                      {customerAnalytics?.CustomerIntentAndPainPointDetection
                        ?.CustomerExperienceScore?.Rating || "N/A"}
                    </Typography>
                  </Box>
                </CardContent>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper
                sx={{
                  flex: 1,
                  p: 1.5,
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  height: 310,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="body1"
                  mb={2}
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  Frequently Used Words
                  <Tooltip title="Gives the most frequently used words during the conversation from the customers side.">
                    <InfoIcon sx={{ fontSize: 18, color: "grey" }} />
                  </Tooltip>
                </Typography>

                <Box
                  sx={{
                    borderRadius: 3,
                    bgcolor: "#f9fafb",
                    border: "1px solid #e5e7eb",
                    p: 2,
                  }}
                >
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {customerAnalytics?.KeywordsAndThemes?.FrequentKeywords
                      ?.length ? (
                      customerAnalytics.KeywordsAndThemes.FrequentKeywords.map(
                        (word, i) => (
                          <Chip
                            key={i}
                            size="small"
                            label={word}
                            sx={{
                              backgroundColor: colors[i % colors.length],
                              color: "black",
                              fontWeight: 400,
                              fontSize: "0.875rem",
                            }}
                          />
                        )
                      )
                    ) : (
                      <Chip
                        label="No data available."
                        size="small"
                        sx={{
                          backgroundColor: "#E4E5E7",
                          color: "#5F6062",
                          fontWeight: 500,
                          px: 1.5,
                          py: 0.5,
                          borderRadius: "4px",
                        }}
                      />
                    )}
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomerSentiment;
